<template lang="">
    <div>
      <!-- Modal -->
      <div class="text-[13px] z-50" v-if="showForm">
        <h2 class="text-black font-bold text-2xl mb-3">Download Brochure</h2>
        <div>
          <form
            class="space-y-3 md:p-4 font-normal"
            @submit="$emit('closeWidget')"
            @submit.prevent="enquireSubmit"
          >
            <input
              type="text"
              placeholder="Enter Name *"
              id="name"
              class="p-2 rounded-md w-full border border-[#ccc]"
              required
            />
            <input
              type="email"
              placeholder="Enter Email Address *"
              id="email"
              class="p-2 rounded-md w-full border border-[#ccc]"
              required
            />
            <div class="flex flex-col gap-2">
              <div class="flex items-center justify-center">
                <select
                  v-model="selectedCountryCode"
                  @change="handleChange"
                  class="text-sm w-[83px] bg-white p-2 border border-[#ccc] rounded-md"
                  required
                >
                  <option
                    v-for="country in countryCodes"
                    :key="country.code"
                    :value="country.code"
                  >
                    {{
                      selectedCountryCode === country.code
                        ? country.code
                        : `${country.code} ${country.name}`
                    }}
                  </option>
                </select>
                <input
                  type="tel"
                  placeholder="Mobile Number *"
                  id="phone"
                  maxlength="10"
                  @input="onPhoneNumberChange"
                  v-model="phoneNumber"
                  class="p-2 rounded-md w-full border border-[#ccc]"
                  ref="phone"
                  required
                />
                <button
                  type="button"
                  class="flex p-2 md:w-[100px] w-[140px]"
                  :class="{
                    'bg-[#d02829]': !otpSent,
                    'bg-green-500': otpSent,
                    'text-white': true,
                    'font-semibold': true,
                    'rounded-r-md': true,
                    'cursor-pointer': !otpSent && phoneNumber.length === 10,
                    'opacity-50 cursor-not-allowed':
                      otpSent || phoneNumber.length !== 10,
                  }"
                  @click="getOtp"
                  :disabled="otpSent || phoneNumber.length !== 10"
                >
                  {{ otpSent ? "OTP Sent" : "Get OTP" }}
                </button>
              </div>
              <span class="text-red-500 text-[9px] text-left pl-0 font-bold">{{
                message
              }}</span>
              <input
                type="text"
                placeholder="Enter OTP *"
                id="otp"
                maxlength="4"
                class="p-2 rounded-md w-full border mt-[-5px] border-[#ccc]"
                v-model="enteredOtp"
                :class="{ border: true, 'border-red-500': errorStatus }"
                ref="otp"
                pattern="[0-9]*"
                required
                @input="sanitizeInput"
              />
              <span
                v-if="errorStatus"
                class="text-red-500 text-[9px] text-left pl-0 font-bold"
              >
                Invalid OTP
              </span>
            </div>
            
           
            <div class="flex gap-4 text-xs items-start text-left text-black">
              <input type="checkbox" checked />
              <span class="text-justify"
                >I authorize Vignan Online and its associates to contact me with
                updates & notifications via email, SMS, WhatsApp, and voice call.
                This consent will override any registration for DNC/NDNC.</span
              >
            </div>
            <button
              type="submit"
              class="w-full text-white font-semibold bg-[#d02829] hover:bg-[#ca9216] rounded-lg px-4 py-2 text-center"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    
    </div>
  </template>
<script>
import axios from "axios";
import stateMixins from "@/mixins/stateMixins";
import countryCodes from "@/mixins/countryCodeMixins";
export default {
  name: "BrochureEView",
  mixins: [stateMixins, countryCodes],
  props: ["url", "program"],
  data: () => ({
    showForm: true,
    selectedProgram: "",
    selectedElective: "",
    electiveOptions: [],
    utmSource: "",
    utmSourceCampaign: "",
    utmSourceMedium: "",
    utmAdgroupid: "",
    utmCampaignid: "",
    utmCreativeid: "",
    utmDevice: "",
    utmKeyword: "",
    utmMatchtype: "",
    utmNetwork: "",
    utmPlacement: "",
    utmGclid: "",
    widget_id: "",
    activeTab: "tab-1",
    selectedState: "",
    selectedCity: "",
    cities: [],
    enteredOtp: "",
    otpChecking: false,
    errorStatus: false,
    message: "",
    phoneNumber: "",
    otpSent: false,
    selectedCountryCode: "+91-",
    // countryCodes: [],
  }),

  created() {
    console.log('Props:', this.$props);  // This logs all props
    console.log('Program Prop:', this.program);  // Logs the `program` prop specifically
    console.log('URL Prop:', this.url);

    console.log(this.$route.path);
    this.widget_id = this.widget_prop_id;
    this.utmSource = this.$route.query.utm_source || "Organic Search";
    this.utmSourceCampaign = this.$route.query.utm_campaign || "website";
    this.utmSourceMedium = this.$route.query.utm_medium || "";
    this.utmAdgroupid = this.$route.query.utm_adgroupid || "";
    this.utmCampaignid = this.$route.query.utm_campaignid || "";
    this.utmCreativeid = this.$route.query.utm_creativeid || "";
    this.utmDevice = this.$route.query.utm_device || "";
    this.utmKeyword = this.$route.query.utm_keyword || "";
    this.utmMatchtype = this.$route.query.utm_matchtype || "";
    this.utmNetwork = this.$route.query.utm_network || "";
    this.utmPlacement = this.$route.query.utm_placement || "";
    this.Gclid = this.$route.query.gclid || "";
  },
  updated() {
    console.log(this.selectedProgram);
  },

  methods: {
    onStateChange() {
      const state = this.stateList.find((s) => s.state === this.selectedState);
      this.cities = state ? state.districts : [];
      this.selectedCity = "";
    },

    sanitizeInput() {
      // Remove non-numeric characters
      this.enteredOtp = this.enteredOtp.replace(/[^0-9]/g, "");
    },

    onPhoneNumberChange() {
      // Reset the error message when the phone number changes
      this.message = "";

      // Reset otpSent when the phone number changes
      this.otpSent = false;

      // Remove non-numeric characters from the phone number
      this.phoneNumber = this.phoneNumber.replace(/\D/g, "");

      // Limit the phone number to a maximum length of 10 digits
      if (this.phoneNumber.length > 10) {
        this.phoneNumber = this.phoneNumber.slice(0, 10);
      }
    },

    handleKeyPress(event) {
      // Allow only numeric input and backspace
      if (
        !(event.charCode >= 48 && event.charCode <= 57) &&
        event.charCode !== 8
      ) {
        event.preventDefault();
      }
    },
    async getOtp() {
      try {
        const json_data = {
          phone: this.phoneNumber,
        };
        const response = await axios.post(
          `${process.env.VUE_APP_API}/mob_otp_send/`,
          json_data
        );
        console.log(response);
        this.otpSent = true;
      } catch (error) {
        console.error("Error getting OTP:", error);
      }
    },

    enquireSubmit(el) {
  let dataJson = [
    {
      Attribute: "FirstName",
      Value: el.target.elements.name.value,
    },
    {
      Attribute: "EmailAddress",
      Value: el.target.elements.email.value,
    },
    {
      Attribute: "Phone",
      Value: el.target.elements.phone.value,
    },

    {
      Attribute: "mx_utm_Source",
      Value: this.utmSource,
    },
    {
      Attribute: "SourceCampaign",
      Value: this.utmSourceCampaign,
    },
    {
      Attribute: "SourceMedium",
      Value: this.utmSourceMedium,
    },
    {
      Attribute: "mx_utm_Adgroupid",
      Value: this.utmAdgroupid,
    },
    {
      Attribute: "mx_utm_Campaignid",
      Value: this.utmCampaignid,
    },
    {
      Attribute: "mx_utm_Creativeid",
      Value: this.utmCreativeid,
    },
    {
      Attribute: "mx_utm_Device",
      Value: this.utmDevice,
    },
    {
      Attribute: "mx_utm_Keyword",
      Value: this.utmKeyword,
    },
    {
      Attribute: "mx_utm_Matchtype",
      Value: this.utmMatchtype,
    },
    {
      Attribute: "mx_utm_Network",
      Value: this.utmNetwork,
    },
    {
      Attribute: "mx_utm_Placement",
      Value: this.utmPlacement,
    },
  ];

  console.log(dataJson);

  axios
    .post(
      "https://api.vignanonline.com/api/capture-lead/",
      dataJson
    )
    .then(async (resp) => {
      console.log(resp, "this is resp");

      el.target.reset();
      this.errorStatus = false;

      // After successful form submission, update the program data if needed
      this.programs = resp.data.programs || []; // Assuming `resp.data.programs` contains the updated program data

      // Dynamically download the brochure for the current program (slug)
      this.downloadBrochure();
    });
},

// downloadBrochure() {
//   const brochureBaseUrl = this.url; 
//   const slug = this.program;

//   if (brochureBaseUrl && slug) {
//     const downloadUrl = `${brochureBaseUrl}`;

//     console.log("Attempting to download brochure from:", downloadUrl);
//     const a = document.createElement('a');
//     a.href = downloadUrl;
//     a.download = `${slug}-brochure.pdf`;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.open(downloadUrl, '_blank');
//   } else {
//     console.log("Brochure URL or program slug not available.");
//   }
// },

downloadBrochure() {
  const brochureBaseUrl = this.url;  // Ensure this is the correct URL
  const slug = this.program;         // Ensure this is a valid program slug

  if (brochureBaseUrl && slug) {
    const downloadUrl = `${brochureBaseUrl}`;  // Construct full URL

    console.log("Attempting to open brochure from:", downloadUrl);

    // Fetch the file (for example using the Fetch API)
    fetch(downloadUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error("File not found or failed to fetch.");
        }
        return response.blob();  // Get the file as a Blob
      })
      .then(blob => {
        const a = document.createElement('a');
        const url = URL.createObjectURL(blob);  // Create a URL for the Blob
        a.href = url;
        a.target = '_self';  // Open in the same window or tab

        // Use the correct file name for the download
        a.download = `${slug}.pdf`;

        document.body.appendChild(a);
        a.click();  // Simulate a user click

        // Clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(url);  // Revoke the object URL after download
      })
      .catch(error => {
        console.error("Failed to download the brochure:", error);
      });
  } else {
    console.log("Brochure URL or program slug not available.");
  }
}



  },
};
</script>
<style scoped></style>
